var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKucoin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7276_478020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40.2939C31.0457 40.2939 40 31.3396 40 20.2939C40 9.24825 31.0457 0.293945 20 0.293945C8.9543 0.293945 0 9.24825 0 20.2939C0 31.3396 8.9543 40.2939 20 40.2939Z",
    fill: "#23AF91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 20.2979L22.5625 26.2236L26.3008 22.4854C26.9688 21.8838 27.9922 21.9111 28.6289 22.5479C29.2656 23.1846 29.293 24.208 28.6914 24.876L23.7578 29.8057C23.0938 30.458 22.0312 30.458 21.3711 29.8057L14.2539 22.6846V26.915C14.2539 27.8486 13.4961 28.6064 12.5625 28.6064C11.6289 28.6064 10.8711 27.8486 10.8711 26.915V13.6689C10.8711 12.7354 11.6289 11.9775 12.5625 11.9775C13.4961 11.9775 14.2539 12.7354 14.2539 13.6689V17.8994L21.3711 10.7822C22.0352 10.1299 23.0977 10.1299 23.7578 10.7822L28.6953 15.7158C29.2969 16.3838 29.2695 17.4072 28.6328 18.0439C27.9961 18.6807 26.9727 18.708 26.3047 18.1064L22.5664 14.3682L16.6406 20.2979ZM22.5703 18.6025C21.8867 18.6025 21.2695 19.0127 21.0039 19.6455C20.7422 20.2783 20.8867 21.0049 21.3711 21.4893C21.8555 21.9736 22.582 22.1182 23.2148 21.8564C23.8477 21.5947 24.2617 20.9775 24.2617 20.2939C24.2617 19.8447 24.082 19.415 23.7656 19.0947C23.4492 18.7822 23.0195 18.6025 22.5703 18.6025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7276_478020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.293945)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKucoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kucoin.67c12b62759f17248fd5f4ffd28dec85.svg";